export default __webpack_public_path__ + "static/media/innovation.684eda19.png";